/**
 * Formats a Date into a localized string.
 * @param date - The date to format
 * @param options - Intl.DateTimeFormatOptions to customize the output (defaults to MMM DD, YYYY)
 * @param locale - BCP 47 locale string (defaults to "en-US")
 * @returns Formatted date string
 */
export const formatDate = (
  date: Date,
  options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric", year: "numeric" },
  locale: string = "en-US"
): string => {
  return new Date(date).toLocaleDateString(locale, options);
};
